<div class="search-input">
  @if (isSearching$ | async) {
    <mat-spinner class="search-input-icon" diameter="20"></mat-spinner>
  } @else {
    <mat-icon class="search-input-icon">search</mat-icon>
  }

  <input
    type="search"
    data-test-id="omnisearch-input"
    class="search-input-input"
    placeholder="Search for experts, projects or clients..."
    [(ngModel)]="searchTerm"
    (keyup)="submitSearch(searchTerm)"
    (focus)="onFocus()"
  />
</div>

@if (results$ | async; as results) {
  @if (showDropdown && (isSearching$ | async) === false) {
    <div class="drop-down" (appClickOutside)="clearSearch()">
      @if (results.length) {
        <div class="omnisearch-tabs" data-test-id="omnisearch-tabs">
          @for (tab of allTabs; track tab) {
            @if (hasEntity(results, tab.value)) {
              <button
                class="omnisearch-tab"
                [class.active]="activeTab === tab.value"
                [attr.data-test-id]="`omnisearch-tab-${tab.value}`"
                (click)="selectTab(tab.value)"
              >
                {{ tab.label }} ({{ getTabCount(results, tab.value) }})
              </button>
            }
          }
        </div>
        <cdk-virtual-scroll-viewport class="w-full" itemSize="80">
          <div class="mx-4">
            @for (data of filterResults(results); track data) {
              <app-omnisearch-result
                data-test-id="omnisearch-result-item"
                [omnisearchResponse]="data"
                [searchTerm]="searchTerm"
              >
              </app-omnisearch-result>
            }
          </div>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="no-results" data-test-id="omnisearch-no-results">
          <mat-icon>search_off</mat-icon>
          <span>No results found for "{{ searchTerm }}"</span>
        </div>
      }
    </div>
  }
}
